<template>
    <ThLink
        v-qa="'saved-products'"
        class="wishlist-trigger"
        type="button"
        aria-label="Saved products"
        @click="toggleSavedProductsModal"
    />
</template>

<script setup lang="ts">
import ThLink from '@/components/ui/buttons/ThLink.vue'
import { useWishlistTrigger } from './useWishlistTrigger'

const { toggleSavedProductsModal } = useWishlistTrigger()
</script>
